import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileBottomBar } from "./MobileBottomBar";
import type { Salon } from "@/data/types";
import { withBookingUtm } from "@/lib/booking";
import { salonForPath } from "@/lib/serviceBooking";
import { useRouterState } from "@tanstack/react-router";

interface Props {
  children: ReactNode;
  contextSalon?: Salon | null;
}

export function SiteShell({ children, contextSalon = null }: Props) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const salon = contextSalon ?? salonForPath(pathname);
  return (
    <div className="min-h-screen flex flex-col">
      <Header bookingUrl={salon ? withBookingUtm(salon.bokaDirektUrl) : undefined} />
      <main className="flex-1 pb-24 md:pb-0">{children}</main>
      <Footer />
      <MobileBottomBar salon={salon} />
    </div>
  );
}
